import React, { useState } from 'react';
import { apiJson } from '../apiClient';
import { FACTORY_RAW_MATERIAL_CATEGORIES, factoryCategoryShort } from '../constants/factoryStockCategories';
import './AddProductPage.css';

export default function AddRawMaterialCategoryPage({ onNavigate }) {
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const go = (key) => {
    if (typeof onNavigate === 'function') onNavigate(key);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const label = name.trim();
    if (!label) {
      setError('Enter a category name.');
      return;
    }
    setBusy(true);
    setError('');
    setSuccess('');
    try {
      const data = await apiJson('/brick/raw-material-categories', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: label }),
      });
      setSuccess(data.message || 'Category saved.');
      setName('');
      setTimeout(() => go('raw-materials-overview'), 600);
    } catch (err) {
      setError(err.body?.message || err.message || 'Could not save category.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="stock-add-page page-bleed">
      <header className="stock-add-header">
        <h1 className="stock-add-title">Add category</h1>
        <p className="stock-add-lede">
          Create a raw material type for your factory (e.g. Water, Diesel). It is saved as{' '}
          <strong>Raw materials — …</strong> and appears when adding materials.
        </p>
      </header>

      <div className="stock-add-card">
        <form className="stock-add-form" onSubmit={handleSubmit} noValidate>
          <label className="stock-add-field stock-add-field--full">
            <span className="stock-add-label">Category name</span>
            <input
              className="stock-add-input"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Water, Diesel, Pallets"
              required
              disabled={busy}
              autoComplete="off"
            />
            <span className="stock-add-hint">
              Built-in types: {FACTORY_RAW_MATERIAL_CATEGORIES.map((c) => factoryCategoryShort(c)).join(', ')}.
            </span>
          </label>

          {error ? (
            <div className="stock-add-alert stock-add-alert--error" role="alert">
              {error}
            </div>
          ) : null}
          {success ? (
            <div className="stock-add-alert" role="status" style={{ background: '#ecfdf5', color: '#065f46' }}>
              {success}
            </div>
          ) : null}

          <div className="stock-add-actions">
            <button type="submit" className="stock-add-submit" disabled={busy}>
              {busy ? 'Saving…' : 'Save category'}
            </button>
            <button
              type="button"
              className="stock-add-secondary"
              onClick={() => go('raw-materials-overview')}
              disabled={busy}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
